import { css } from 'lit';
export default css `
  :host {
    display: inline-block;
  }

  .badge {
    display: flex;
    align-items: center;
    padding: 4px 12px;
    border-radius: var(--amityeko-radius-medium);
  }

  .badge ::slotted(amityeko-icon) {
    width: 16px;
    padding-right: 4px;
    --amityeko-icon-size: 12px;
  }

  /* VARIANTS */
  /* Variant - default */
  .badge--variant-default {
    background-color: var(--amityeko-color-gray-9);
  }

  .badge--variant-default .badge__label::part(base) {
    color: var(--amityeko-color-gray-3);
  }

  .badge--variant-default ::slotted(amityeko-icon) {
    --amityeko-icon-color: var(--amityeko-color-gray-3);
  }

  /* Variant - primary */
  .badge--variant-primary {
    background-color: var(--amityeko-color-primary-1);
  }

  .badge--variant-primary .badge__label::part(base) {
    color: var(--amityeko-color-primary-7);
  }

  .badge--variant-primary ::slotted(amityeko-icon) {
    --amityeko-icon-color: var(--amityeko-color-primary-7);
  }

  /* Variant - success */
  .badge--variant-success {
    background-color: var(--amityeko-color-success-1);
  }

  .badge--variant-success .badge__label::part(base) {
    color: var(--amityeko-color-success-7);
  }

  .badge--variant-success ::slotted(amityeko-icon) {
    --amityeko-icon-color: var(--amityeko-color-success-7);
  }

  /* Variant - caution */
  .badge--variant-caution {
    background-color: var(--amityeko-color-caution-1);
  }

  .badge--variant-caution .badge__label::part(base) {
    color: var(--amityeko-color-caution-7);
  }

  .badge--variant-caution ::slotted(amityeko-icon) {
    --amityeko-icon-color: var(--amityeko-color-caution-7);
  }

  /* Variant - destructive */
  .badge--variant-destructive {
    background-color: var(--amityeko-color-destructive-1);
  }

  .badge--variant-destructive .badge__label::part(base) {
    color: var(--amityeko-color-destructive-7);
  }

  .badge--variant-destructive ::slotted(amityeko-icon) {
    --amityeko-icon-color: var(--amityeko-color-destructive-7);
  }

  /* Variant - info */
  .badge--variant-info {
    background-color: var(--amityeko-color-info-1);
  }

  .badge--variant-info .badge__label::part(base) {
    color: var(--amityeko-color-info-7);
  }

  .badge--variant-info ::slotted(amityeko-icon) {
    --amityeko-icon-color: var(--amityeko-color-info-7);
  }

  /* Variant - custom */
  .badge--variant-custom {
    background-color: var(--private-bg-color, var(--amityeko-color-gray-9));
  }

  .badge--variant-custom .badge__label::part(base) {
    color: var(--private-color, var(--amityeko-color-gray-3));
  }

  .badge--variant-custom ::slotted(amityeko-icon) {
    --amityeko-icon-color: var(--private-color, var(--amityeko-color-gray-3));
  }
`;
//# sourceMappingURL=styles.js.map